export enum FieldValidationCodes {
    Undefined               = "",
    // Payee
    PayeeName               = "payeeName",
    PayeeReference          = "payeeReference",
    PayeeType               = "payeeType",
    PayeeSortCode           = "sortCode",
    PayeeAccountNumber      = "payeeAccountNumber",
    PayeeIBAN               = "payeeIBAN",
    PayeeCountry            = "payeeCountry",
    // Payment Order
    PaymentOrderScheme              = "paymentOrderScheme",
    PaymentOrderPayee               = "paymentOrderPayee",
    PaymentOrderAmount              = "paymentOrderAmount",
    PaymentOrderName                = "paymentOrderName",
    PaymentOrderCancelRejectReason  = "paymentOrderCancelRejectReason",
    PaymentOrderScheduleFrequency   = "paymentOrderScheduleFrequency",
    PaymentOrderScheduleStartDate   = "paymentOrderScheduleStartDate",
    // Fee
    Fee_Description         = "feeDescription",
    FeeTypes                = "feeTypes",
    // Person
    Title                   = "title",
    FirstName               = "firstName",
    LastName                = "lastName",
    Email                   = "email",
    PhoneNumber             = "phoneNumber",
    // Address (not mandatory)
    AddressLine1            = "addressLine1",
    AddressLine2            = "addressLine2",
    City                    = "city",
    PostCode                = "postCode",
    Country                 = "country",
    // Address (mandatory)
    AddressLine1Mandatory   = "addressLine1Mandatory",
    AddressLine2Mandatory   = "addressLine2Mandatory",
    CityMandatory           = "cityMandatory",
    PostCodeMandatory       = "postCodeMandatory",
    CountryMandatory        = "countryMandatory",
    // Organisation
    OrganisationName        = "organisationName",
    RegistrationNumber      = "registrationNumber",
    RegistrationCountry     = "registrationCountry",
    // Webhook
    WebhookName             = "webhookName",
    WebhookUrl              = "webhookUrl",
    // App Medium
    AppMediumName           = "appMediumName",
    TokenLifetime           = "tokenLifetime",
    CSR                     = "csr",
    // Rate Source
    RateSource_Name          = "rateSource.name",
    // Rate
    Rate_Rate                = "rate.rate",
    Rate_FromDate            = "rate.fromDate",
    // Sub Transaction Type
    SubTransactionType_Code = "subTransactionType.code",
    SubTransactionType_Description = "subTransactionType.description",
    // Product
    Product_State = "product.state",
    Product_CurrentIssueId   = "product.currentIssueId",
    Product_CurrentIssueNumber = "product.currentIssueNumber",
    Product_UnPublishedChanges = "product.unPublishedChanges",
    Product_GeneralSettings_Name = "product.generalSettings.name",
    Product_GeneralSettings_Code = "product.generalSettings.code",
    Product_GeneralSettings_DefaultWalletCurrency = "product.generalSettings.defaultWalletCurrency",
    Product_GeneralSettings_TargetCustomerType = "product.generalSettings.targetCustomerType",
    Product_GeneralSettings_Description = "product.generalSettings.description",
    // Product Migration
    ProductMigration_FromProduct = "productMigration.fromProduct",
    ProductMigration_FromProductIssue = "productMigration.fromProductIssue",
    ProductMigration_ToProductIssue = "productMigration.toProductIssue",
    ProductMigration_Name = "productMigration.name",
    // Product General Ledger Settings
    Product_GeneralLedgerSettings_GeneralLedgerName = "product.generalLedgerSettings.generalLedgerName",
    // Deposit Product Bank Settings
    Product_DepositBankSettings_Available = "product.depositBankSettings.available",
    Product_DepositBankSettings_Overridable = "product.depositBankSettings.overridable",
    Product_DepositBankSettings_BacsInboundEnabled = "product.depositBankSettings.bacsInboundEnabled",
    Product_DepositBankSettings_BacsOutboundEnabled = "product.depositBankSettings.bacsOutboundEnabled",
    Product_DepositBankSettings_ChapsInboundEnabled = "product.depositBankSettings.chapsInboundEnabled",
    Product_DepositBankSettings_ChapsOutboundEnabled = "product.depositBankSettings.chapsOutboundEnabled",
    Product_DepositBankSettings_DirectCreditsEnabled = "product.depositBankSettings.directCreditsEnabled",
    Product_DepositBankSettings_DirectDebitsEnabled = "product.depositBankSettings.directDebitsEnabled",
    Product_DepositBankSettings_FasterPaymentsInboundEnabled = "product.depositBankSettings.fasterPaymentsInboundEnabled",
    Product_DepositBankSettings_FasterPaymentsOutboundEnabled = "product.depositBankSettings.fasterPaymentsOutboundEnabled",
    // Deposit Product Card Settings
    Product_DepositCardSettings_Available = "product.depositCardSettings.available",
    Product_DepositCardSettings_Overridable = "product.depositCardSettings.overridable",
    // Deposit Product Interest Settings
    Product_DepositInterestSettings_Available = "product.depositInterestSettings.available",
    Product_DepositInterestSettings_Overridable = "product.depositInterestSettings.overridable",
    Product_DepositInterestSettings_Enabled = "product.depositInterestSettings.enabled",
    Product_DepositInterestSettings_RateType = "product.depositInterestSettings.rateType",
    Product_DepositInterestSettings_RateValue = "product.depositInterestSettings.rateValue",
    Product_DepositInterestSettings_RateSourceId = "product.depositInterestSettings.rateSourceId",
    Product_DepositInterestSettings_DaysInYearType = "product.depositInterestSettings.daysInYearType",
    Product_DepositInterestSettings_NonWorkingDaysType = "product.depositInterestSettings.nonWorkingDaysType",
    Product_DepositInterestSettings_PostingScheduleType = "product.depositInterestSettings.postingScheduleType",
    Product_DepositInterestSettings_CalculatedOnBalanceType = "product.depositInterestSettings.calculatedOnBalanceType",
    Product_DepositInterestSettings_AccruedPeriodType = "product.depositInterestSettings.accruedPeriodType",
    Product_DepositInterestSettings_AccruedPeriodValue = "product.depositInterestSettings.accruedPeriodValue",
    Product_DepositInterestSettings_AccruedPeriodOnDayOfWeek = "product.depositInterestSettings.accruedPeriodOnDayOfWeek",
    Product_DepositInterestSettings_AccruedPeriodOnDayOfMonth = "product.depositInterestSettings.accruedPeriodOnDayOfMonth",
    Product_DepositInterestSettings_AccruedPeriodOnMonth = "product.depositInterestSettings.accruedPeriodOnMonth",
    Product_DepositInterestSettings_PostedPeriodType = "product.depositInterestSettings.postedPeriodType",
    Product_DepositInterestSettings_PostedPeriodValue = "product.depositInterestSettings.postedPeriodValue",
    Product_DepositInterestSettings_PostedPeriodOnDayOfWeek = "product.depositInterestSettings.postedPeriodOnDayOfWeek",
    Product_DepositInterestSettings_PostedPeriodOnDayOfMonth = "product.depositInterestSettings.postedPeriodOnDayOfMonth",
    Product_DepositInterestSettings_PostedPeriodOnMonth = "product.depositInterestSettings.postedPeriodOnMonth",
    // Deposit Product Overdraft Settings
    Product_DepositOverdraftSettings_Available = "product.depositOverdraftSettings.available",
    Product_DepositOverdraftSettings_Overridable = "product.depositOverdraftSettings.overridable",
    Product_DepositOverdraftSettings_Enabled = "product.depositOverdraftSettings.enabled",
    Product_DepositOverdraftSettings_SoftLimit = "product.depositOverdraftSettings.softLimit",
    Product_DepositOverdraftSettings_HardLimit = "product.depositOverdraftSettings.hardLimit",
    Product_DepositOverdraftSettings_ReviewPeriodType = "product.depositOverdraftSettings.reviewPeriodType",
    Product_DepositOverdraftSettings_ReviewPeriodValue = "product.depositOverdraftSettings.reviewPeriodValue",
    Product_DepositOverdraftSettings_ReviewDateUtc = "product.depositOverdraftSettings.reviewDate",
    // Deposit Product Overdraft Interest Settings
    Product_DepositOverdraftInterestSettings_Available = "product.depositOverdraftInterestSettings.available",
    Product_DepositOverdraftInterestSettings_Overridable = "product.depositOverdraftInterestSettings.overridable",
    Product_DepositOverdraftInterestSettings_Enabled = "product.depositOverdraftInterestSettings.enabled",
    Product_DepositOverdraftInterestSettings_InterestBearingThreshold = "product.depositOverdraftInterestSettings.interestBearingThreshold",
    Product_DepositOverdraftInterestSettings_RateType = "product.depositOverdraftInterestSettings.rateType",
    Product_DepositOverdraftInterestSettings_RateValue = "product.depositOverdraftInterestSettings.rateValue",
    Product_DepositOverdraftInterestSettings_RateSourceId = "product.depositOverdraftInterestSettings.rateSourceId",
    Product_DepositOverdraftInterestSettings_DaysInYearType = "product.depositOverdraftInterestSettings.daysInYearType",
    Product_DepositOverdraftInterestSettings_NonWorkingDaysType = "product.depositOverdraftInterestSettings.nonWorkingDaysType",
    Product_DepositOverdraftInterestSettings_CalculatedOnBalanceType = "product.depositOverdraftInterestSettings.calculatedOnBalanceType",
    Product_DepositOverdraftInterestSettings_AccruedPeriodType = "product.depositOverdraftInterestSettings.accruedPeriodType",
    Product_DepositOverdraftInterestSettings_AccruedPeriodValue = "product.depositOverdraftInterestSettings.accruedPeriodValue",
    Product_DepositOverdraftInterestSettings_AccruedPeriodOnDayOfWeek = "product.depositOverdraftInterestSettings.accruedPeriodOnDayOfWeek",
    Product_DepositOverdraftInterestSettings_AccruedPeriodOnDayOfMonth = "product.depositOverdraftInterestSettings.accruedPeriodOnDayOfMonth",
    Product_DepositOverdraftInterestSettings_AccruedPeriodOnMonth = "product.depositOverdraftInterestSettings.accruedPeriodOnMonth",
    Product_DepositOverdraftInterestSettings_AccruedOnType = "product.depositOverdraftInterestSettings.accruedOnType",
    Product_DepositOverdraftInterestSettings_PostedPeriodType = "product.depositOverdraftInterestSettings.postedPeriodType",
    Product_DepositOverdraftInterestSettings_PostedPeriodValue = "product.depositOverdraftInterestSettings.postedPeriodValue",
    Product_DepositOverdraftInterestSettings_PostedPeriodOnDayOfWeek = "product.depositOverdraftInterestSettings.postedPeriodOnDayOfWeek",
    Product_DepositOverdraftInterestSettings_PostedPeriodOnDayOfMonth = "product.depositOverdraftInterestSettings.postedPeriodOnDayOfMonth",
    Product_DepositOverdraftInterestSettings_PostedPeriodOnMonth = "product.depositOverdraftInterestSettings.postedPeriodOnMonth",
    // Deposit Product Current Account Settings
    Product_DepositCurrentAccountSettings_Available = "product.depositCurrentAccountSettings.available",
    Product_DepositCurrentAccountSettings_Overridable = "product.depositCurrentAccountSettings.overridable",
    Product_DepositCurrentAccountSettings_MinimumBalance = "product.depositCurrentAccountSettings.minimumBalance",
    Product_DepositCurrentAccountSettings_MaximumBalance = "product.depositCurrentAccountSettings.maximumBalance",
    // Deposit Product Fixed Term Settings
    Product_DepositFixedTermSettings_TermPeriodValue = "product.depositFixedTermSettings.termPeriodValue",
    Product_DepositFixedTermSettings_InitialDepositWindowPeriodValue = "product.depositFixedTermSettings.initialDepositWindowPeriodValue",
    Product_DepositFixedTermSettings_FundingWindowPeriodValue = "product.depositFixedTermSettings.fundingWindowPeriodValue",
    Product_DepositFixedTermSettings_FundingWindowStartDate = "product.depositFixedTermSettings.fundingWindowStartDate",
    // Deposit Product Fixed Term Maturity Settings
    Product_DepositFixedTermMaturitySettings_MaturityAction = "product.depositFixedTermMaturitySettings.maturityAction",
    Product_DepositFixedTermSettings_MinimumBalance = "product.depositFixedTermSettings.minimumBalance",
    Product_DepositFixedTermSettings_MaximumBalance = "product.depositFixedTermSettings.maximumBalance",
    Product_DepositFixedTermMaturitySettings_MaturityWindowStartDate = "product.depositFixedTermMaturitySettings.maturityWindowStartDate",
    Product_DepositFixedTermMaturitySettings_MaturityDate = "product.depositFixedTermMaturitySettings.maturityDate",
    Product_DepositFixedTermMaturitySettings_MaturityAction1ProductId = "product.depositFixedTermMaturitySettings.maturityAction1ProductId",
    // Deposit Instant Access Settings
    Product_DepositInstantAccessSettings_InitialDepositWindowPeriodValue = "product.depositInstantAccessSettings.initialDepositWindowPeriodValue",
    Product_DepositInstantAccessSettings_FundingWindowPeriodValue = "product.depositInstantAccessSettings.fundingWindowPeriodValue",
    // Deposit Cooling Off Settings
    Product_DepositCoolingOffSettings_CoolingOffPeriodValue = "product.depositCoolingOffSettings.coolingOffPeriodValue",
    // Deposit Payment Order Settings
    Product_DepositPaymentOrderSettings_NoticePeriodValue = "product.depositPaymentOrderSettings.noticePeriodValue",
    // Lending Product Interest Settings
    Product_LendingInterestSettings_RateSourceId = "product.lendingInterestSettings.rateSourceId",
    Product_LendingInterestSettings_RateChangedPeriodValue = "product.lendingInterestSettings.rateChangedPeriodValue",
    Product_LendingInterestSettings_AccruedPeriodValue = "product.lendingInterestSettings.accruedPeriodValue",
    Product_LendingInterestSettings_AccruedPeriodOnDayOfWeek = "product.lendingInterestSettings.accruedPeriodOnDayOfWeek",
    Product_LendingInterestSettings_AccruedPeriodOnDayOfMonth = "product.lendingInterestSettings.accruedPeriodOnDayOfMonth",
    Product_LendingInterestSettings_AccruedPeriodOnMonth = "product.lendingInterestSettings.accruedPeriodOnMonth",
    // Lending Product Schedule Settings
    Product_LendingScheduleSettings_PaymentIntervalPeriodValue = "product.lendingScheduleSettings.paymentIntervalPeriodValue",
    Product_LendingScheduleSettings_NumberOfInstallments = "product.lendingScheduleSettings.numberOfInstallments",
    Product_LendingScheduleSettings_NumberOfInstallmentsMinimum = "product.lendingScheduleSettings.numberOfInstallmentsMinimum",
    Product_LendingScheduleSettings_NumberOfInstallmentsMaximum = "product.lendingScheduleSettings.numberOfInstallmentsMaximum",
    Product_LendingScheduleSettings_FirstDueDateOffsetPeriodValue = "product.lendingScheduleSettings.firstDueDateOffsetPeriodValue",
    Product_LendingScheduleSettings_FirstDueDateOffsetPeriodValueMinimum = "product.lendingScheduleSettings.firstDueDateOffsetPeriodValueMinimum",
    Product_LendingScheduleSettings_FirstDueDateOffsetPeriodValueMaximum = "product.lendingScheduleSettings.firstDueDateOffsetPeriodValueMaximum",
    Product_LendingScheduleSettings_GracePeriodValue = "product.lendingScheduleSettings.gracePeriodValue",
    // Lending Product Term Settings
    Product_LendingTermSettings_TermPeriodValue = "product.lendingTermSettings.termPeriodValue",
    // Product Issue
    ProductIssue_State           = "productIssue.state",
    ProductIssue_Code            = "productIssue.code",
    ProductIssue_Name            = "productIssue.name",
    // Product Fees
    Product_ManualFee_Name = "product.manualFee.name",
    Product_ManualFee_Reference = "product.manualFee.reference",
    Product_ScheduledFee_Name = "product.scheduledFee.name",
    Product_ScheduledFee_Reference = "product.scheduledFee.reference",
    Product_ScheduledFee_PeriodType = "product.scheduledFee.periodType",
    Product_ScheduledFee_PeriodOnDayOfWeek = "product.scheduledFee.periodOnDayOfWeek",
    Product_ScheduledFee_PeriodOnDayOfMonth = "product.scheduledFee.periodOnDayOfMonth",
    Product_ScheduledFee_PeriodOnMonth = "product.scheduledFee.periodOnMonth",
    Product_TransactionalFee_TransactionType = "product.transactionalFee.transactionType",
    Product_TransactionalFee_Name = "product.transactionalFee.name",
    Product_TransactionalFee_Reference = "product.transactionalFee.reference",
    // Product Secondary Wallet Type
    Product_SecondaryWalletType_Code = "product.secondaryWalletType.code",
    Product_SecondaryWalletType_Name = "product.secondaryWalletType.name",
    Product_SecondaryWalletType_AllowedCurrencies = "product.secondaryWalletType.allowedCurrencies",
    Product_SecondaryWalletType_Overridable = "product.secondaryWalletType.overridable",
    Product_SecondaryWalletType_Enabled = "product.secondaryWalletType.enabled",
    Product_SecondaryWalletType_RateType = "product.secondaryWalletType.rateType",
    Product_SecondaryWalletType_RateValue = "product.secondaryWalletType.rateValue",
    Product_SecondaryWalletType_RateSourceId = "product.secondaryWalletType.rateSourceId",
    Product_SecondaryWalletType_DaysInYearType = "product.secondaryWalletType.daysInYearType",
    Product_SecondaryWalletType_NonWorkingDaysType = "product.secondaryWalletType.nonWorkingDaysType",
    Product_SecondaryWalletType_CalculatedOnBalanceType = "product.secondaryWalletType.calculatedOnBalanceType",
    Product_SecondaryWalletType_AccruedPeriodType = "product.secondaryWalletType.accruedPeriodType",
    Product_SecondaryWalletType_AccruedPeriodValue = "product.secondaryWalletType.accruedPeriodValue",
    Product_SecondaryWalletType_AccruedPeriodOnDayOfWeek = "product.secondaryWalletType.accruedPeriodOnDayOfWeek",
    Product_SecondaryWalletType_AccruedPeriodOnDayOfMonth = "product.secondaryWalletType.accruedPeriodOnDayOfMonth",
    Product_SecondaryWalletType_AccruedPeriodOnMonth = "product.secondaryWalletType.accruedPeriodOnMonth",
    Product_SecondaryWalletType_PostedPeriodType = "product.secondaryWalletType.postedPeriodType",
    Product_SecondaryWalletType_PostedPeriodValue = "product.secondaryWalletType.postedPeriodValue",
    Product_SecondaryWalletType_PostedPeriodOnDayOfWeek = "product.secondaryWalletType.postedPeriodOnDayOfWeek",
    Product_SecondaryWalletType_PostedPeriodOnDayOfMonth = "product.secondaryWalletType.postedPeriodOnDayOfMonth",
    Product_SecondaryWalletType_PostedPeriodOnMonth = "product.secondaryWalletType.postedPeriodOnMonth",
    // Account
    AccountName = "accountName",
    Account_OverrideTransactionReference = "sccount.overrideTransactionReference",
    Account_ReviewDateUtc = "account.reviewDateUtc",
    Account_State = "account.state",
    Account_StateChangeReasonCode = "account.stateChangeReasonCode",
    Account_StateChangeReasonDescription = "account.stateReasonDescription",
    Account_ProductIssueId = "account.productIssueId",
    Account_Wallets_SecondaryWalletType = "account.wallets.secondaryWalletType",
    Account_Wallets_SecondaryWalletName = "account.wallets.secondaryWalletName",
    Account_Wallets_SecondaryWalletCurrency = "account.wallets.secondaryWalletCurrency",
    Account_Wallets_TransferSourceWallet = "account.wallets.transferSourceWallet",
    Account_Wallets_TransferDestinationWallet = "account.wallets.transferDestinationWallet",
    Account_Wallets_TransferAmount = "account.wallets.transferAmount",
    Account_Wallets_TransferDebitTransactionReference = "account.wallets.transferDebitTransactionReference",
    Account_Wallets_TransferCreditTransactionReference = "account.wallets.transferCreditTransactionReference",
    Account_Wallets_FXSellCurrency = "account.wallets.fxSellCurrency",
    Account_Wallets_FXBuyCurrency = "account.wallets.fxBuyCurrency",
    Account_Wallets_FXType = "account.wallets.fxType",
    Account_Card_WalletID = "account.card.walletId",
    Account_Card_Person = "account.card.person",
    Account_Card_Processor = "account.card.processor",
    Account_Card_AccountIdentifier = "account.card.accountIdentifier",
    // Accouting
    Reports_ReportDate = "reports.reportDate",
    Reports_AccountType = "reports.accountType",
    Reports_AccountSelection = "reports.accountSelection",
    Reports_WalletSelection = "reports.walletSelection",
    GeneralLedger_AccountName = "generalLedger.accountName",
    GeneralLedger_AccountCode = "generalLedger.accountCode",
    // Roles
    Role_Name = "role.name",
    // Region
    Region_Name = "region.name",
    Region_Timezone = "region.timezone",
    Region_DefaultCulture = "region.defaultCulture",
    Region_AvailableCurrencies = "region.availableCurrencies",
    Region_DefaultCurrency = "region.defaultCurrency",
    PublicHoliday_Name = "publicHoliday.name",
    // Testing Tools
    Tools_Adjustment_Reference = "tools.adjustment.reference",
    Tools_Adjustment_DebitCreditCode = "tools.adjustment.debitCreditCode",
    Tools_Adjustment_TransactionType = "tools.adjustment.transactionType",
}

export default FieldValidationCodes